const questions = [
  {
    id: 1,
    question: "She ___ to school every day.",
    options: ["go", "goes", "is going"],
    answer: "goes",
    concept: "present_simple_third_person",
    skill: "verb_form",
    explanation: "He / She / It takes -s in the Present Simple."
  },
  {
    id: 2,
    question: "Which sentence is correct?",
    options: [
      "They plays football on Fridays.",
      "They play football on Fridays.",
      "They playing football on Fridays."
    ],
    answer: "They play football on Fridays.",
    concept: "present_simple_plural",
    skill: "subject_verb_agreement",
    explanation: "Plural subjects use the base verb without -s."
  },
  {
    id: 3,
    question: "___ you like coffee?",
    options: ["Do", "Does", "Are"],
    answer: "Do",
    concept: "present_simple_questions",
    skill: "auxiliary_do",
    explanation: "Use 'Do' with I / you / we / they."
  },
  {
    id: 4,
    question: "He ___ live near here.",
    options: ["don't", "doesn't", "isn't"],
    answer: "doesn't",
    concept: "present_simple_negative",
    skill: "auxiliary_does",
    explanation: "Use doesn't + base verb for he / she / it."
  },
  {
    id: 5,
    question: "Which sentence shows a daily routine?",
    options: [
      "We study English every day.",
      "We are studying English now.",
      "We studied English yesterday."
    ],
    answer: "We study English every day.",
    concept: "present_simple_usage",
    skill: "tense_usage",
    explanation: "Present Simple is used for habits and routines."
  }
];

export default questions;


